<template>
  <div>
    <!-- INPUT FIND -->
    <b-input-group class="mb-3">
      <b-form-input class="col mr-2" readonly v-model="security_provider_id" />
      <b-form-input class="text-uppercase" readonly v-model="provider_name" />
      <b-input-group-append>
        <b-button variant="primary" @click="showModal">
          <i class="fa fa-search"></i>
        </b-button>
      </b-input-group-append>
    </b-input-group>

    <!-- MODAL -->
    <b-modal
      ref="modal-security-provider-find"
      title="Find Security Provider"
      size="xl"
      @hide="modalForcedClose"
      centered
      scrollable
    >
      <div id="wt-modal">
        <!-- LEFT -->
        <div id="wt-modal-left">
          <SecurityProviderFilter></SecurityProviderFilter>
        </div>
        <!-- RIGHT -->
        <div id="wt-modal-right">
          <SecurityProviderGrid
            @selectedGridSecurityProvider="objModal = $event"
            :resetRowSelected="resetRowSelected"
          ></SecurityProviderGrid>
        </div>
      </div>
      <!-- FOOTER -->
      <template v-slot:modal-footer>
        <div ref="modal-mensage" class="text">{{msg}}</div>
        <div class="ml-3">
          <b-button size="sm" pill variant="light" class="mr-2" @click="cancelModal">
            <i class="fas fa-times-circle"></i> Clear
          </b-button>
          <b-button size="sm" pill variant="primary" @click="hideModal">
            <i class="fa fa-check-circle"></i> Confirm
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import SecurityProviderGrid from "./SecurityProviderGrid";
import SecurityProviderFilter from "./SecurityProviderFilter";

export default {
  name: "ResourceFind",
  props: {
    getSecurityProvider: Object,
    urlOrigem: String
  },
  components: { SecurityProviderGrid, SecurityProviderFilter },
  data: function() {
    return {
      objModal: {},
      security_provider_id: null,
      provider_name: null,
      resetRowSelected: false,
      msg: null
    };
  },
  methods: {
    showModal() {
      this.objModal = {};
      this.$store.commit(
        "setUrlServicesStore",
        "security-ds/api/internal/security-provider"
      ),
        this.$store.commit("setViewFind", true),
        this.$refs["modal-security-provider-find"].show();
    },

    hideModal() {
      if (Object.entries(this.objModal).length > 0) {
        this.$emit("securityProviderFind", this.objModal);
        this.$store.commit("setUrlServicesStore", this.urlOrigem),
          this.$store.commit("setViewFind", false),
          this.$refs["modal-security-provider-find"].hide();
      } else if (Object.entries(this.objModal).length === 0) {
        this.$refs["modal-mensage"].classList.add(
          "text-danger",
          "font-weight-bold"
        );
        this.msg = "NO RECORDS SELECTED";
      }
    },

    cancelModal() {
      this.objModal = {};
      this.security_provider_id = null;
      this.provider_name = null;
      this.resetRowSelected = true;
    },

    modalForcedClose() {
      this.$store.commit("setUrlServicesStore", this.urlOrigem),
        this.$store.commit("setViewFind", false);
    }
  },
  watch: {
    getSecurityProvider() {
      this.security_provider_id = this.getSecurityProvider.security_provider_id;
      this.provider_name = this.getSecurityProvider.provider_name;
    },
    objModal() {
      if (Object.entries(this.objModal).length === 0) {
        this.msg = null;
      } else if (Object.entries(this.objModal).length > 0) {
        this.$refs["modal-mensage"].classList.remove(
          "text-danger",
          "font-weight-bold"
        );
        this.msg = `SELECTED: ${this.objModal.security_provider_id}`;
      }
    }
  }
};
</script>
